import Storage from "./localStorage";

const storage = new Storage();

const alpineData = () => {
  return {
    resetCart() {
      storage.removeWarenkorbKey();
      storage.removeBookingData();
      console.log('reset Cart and booking data');
    },
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.appCheckoutSuccess = alpineData;
